import React from "react";
import MuiDialogContent from "@mui/material/DialogContent";

import { useDialogContentStyles } from "./DialogContent.styles";
import { DialogContentProps } from "./DialogContent.types";

function DialogContent(props: DialogContentProps) {
  const { paddingTop, paddingBottom, ...other } = props;

  const dialogContentClasses = useDialogContentStyles(props);

  return <MuiDialogContent classes={dialogContentClasses} {...other} />;
}

export default DialogContent;
